import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';

import { redirectus as redirectAction } from 'ggApp/modules/router/actions';
import { storeActive } from 'ggApp/modules/store/selectors';

//
//  This component will be removed soon
//  (once automatic emails are adjusted for newer URL)
//  New password recovery URL: /{store}-{lang}/auth?flow=PASSWORD_SETUP
//  reset_password_token param is still required in the location.query
//
@connect(
    createStructuredSelector({
        store: storeActive,
    }),
    (dispatch) => ({
        redirect: bindActionCreators(redirectAction, dispatch),
    }),
)
export default class LegacyPasswordRecovery extends React.Component {
    componentDidMount() {
        this.redirectToNewAuth();
    }

    redirectToNewAuth = () => {
        // eslint-disable-next-line
        const { redirect, store, location } = this.props;

        // eslint-disable-next-line
        const { reset_password_token: token } = location.query;

        // eslint-disable-next-line
        redirect(`/${store.code}-${store.activeLanguage}/auth?flow=PASSWORD_SETUP&reset_password_token=${token}`, true);
    };

    render() {
        return null;
    }
}
